import { cloneDeep, pick } from 'lodash'
import Vue from 'vue'
import QuizPlayer from './components/quiz_player.vue'
import { quizPlayerStore } from './store'

export function quizPlayer(quizData) {
  if (!quizData || !quizData.take) return;
  quizData = cloneDeep(quizData)
  buildQuizPlayer(quizData)
}

function buildQuizPlayer(quizData) {
  const data = pick(quizData, ['questions', 'take'])
  const store = quizPlayerStore(quizData.target, data)

  return new Vue({
    el: '#quiz-player-block',
    store,
    render: h => h(QuizPlayer, {
      props: {
        loggedIn: SOPHIA.loggedIn(),
        target: quizData.target,
        nextUrl: quizData.nextUrl
      }
    })
  });
}
